import { ModelBase } from '../../core/model/model-base';
import { Address } from '../../common/model/address';
import { LeaseRow } from './lease-row';
import { LocalDate } from '../../core/model/local-date';
import { Money } from '../../core/model/money';
import { OrganizationOfTenantsKind, RentalObjectCategory } from './const/enums';
import { LeaseAgreementTemplate } from './lease-agreement-template';

export class VacantRentalObject extends ModelBase {
  constructor() {
    super();

    Object.defineProperties(this, {
      _vacantFrom: { writable: true, enumerable: false },
      _vacantTo: { writable: true, enumerable: false },
      _leaseAgreementFromDate: { writable: true, enumerable: false },
      _leaseAgreementLastBillingDate: { writable: true, enumerable: false },
      _blockedFrom: { writable: true, enumerable: false },
      _blockedTo: { writable: true, enumerable: false },
      _vacantOnDate: { writable: true, enumerable: false },
    });

    this.address = new Address();
    this.templates = [];
    this.leaseAgreementTemplate = new LeaseAgreementTemplate();
  }

  private _vacantFrom: LocalDate;
  private _vacantTo: LocalDate;
  private _leaseAgreementFromDate: LocalDate;
  private _leaseAgreementLastBillingDate: LocalDate;
  private _blockedFrom: LocalDate;
  private _blockedTo: LocalDate;
  private _desiredMoveOutDate: LocalDate;
  private _vacantOnDate: LocalDate;

  get vacantOnDate(): LocalDate {
    return this._vacantOnDate;
  }
  set vacantOnDate(value: LocalDate) {
    this._vacantOnDate = LocalDate.fromDate(value);
  }
  get leaseAgreementFromDate(): LocalDate {
    return this._leaseAgreementFromDate;
  }
  set leaseAgreementFromDate(value: LocalDate) {
    this._leaseAgreementFromDate = LocalDate.fromDate(value);
  }
  get leaseAgreementLastBillingDate(): LocalDate {
    return this._leaseAgreementLastBillingDate;
  }
  set leaseAgreementLastBillingDate(value: LocalDate) {
    this._leaseAgreementLastBillingDate = LocalDate.fromDate(value);
  }
  get desiredMoveOutDate(): LocalDate {
    return this._desiredMoveOutDate;
  }
  set desiredMoveOutDate(value: LocalDate) {
    this._desiredMoveOutDate = LocalDate.fromDate(value);
  }
  address: Address;
  currencyCode: string;

  get blockedFrom(): LocalDate {
    return this._blockedFrom;
  }
  set blockedFrom(value: LocalDate) {
    this._blockedFrom = LocalDate.fromDate(value);
  }

  get blockedTo(): LocalDate {
    return this._blockedTo;
  }
  set blockedTo(value: LocalDate) {
    this._blockedTo = LocalDate.fromDate(value);
  }

  atticStorageNumber: string;
  basementStorageNumber: string;
  otherStorageNumber: string;
  parkingIncludedInRent: string;
  blockingReason: string = null;
  blockingWarning: string = null;
  company: string;
  companyId: string;
  leaseAgreementNumber: string;
  monthlyRent: Money;
  property: string;
  propertyId: string;
  rentalId: string;
  rentalObjectId: string;
  rentalObjectType: string;
  street: string;
  surface: number;
  templates: LeaseRow[];
  standardSpecialTerms: string;
  standardRentPaymentTerms: string;
  hasNegotiationProcedure: boolean;
  earlyTerminationIsUsed: boolean;
  allowEarlyTerminationByDefault: boolean;
  furnished: boolean;
  currentPeriodText: string;
  leaseAgreementTemplate: LeaseAgreementTemplate;
  category: RentalObjectCategory;
  movingOutTenantName: string;
  movingOutTenantPhone: string;
  movingOutTenantEmail: string;
  movingInTenantName: string;
  movingInTenantPhone: string;
  movingInTenantEmail: string;
  indvidualMeterWater: boolean;
  indvidualMeterColdWater: boolean;
  indvidualMeterElectricity: boolean;
  indvidualMeterHeating: boolean;
  lettingStatusText: string;
  lettingStatus: number;
  organizationOfTenants: OrganizationOfTenantsKind;
  otherOrganizationOfTenants: string;

  get vacantFrom(): LocalDate {
    return this._vacantFrom;
  }
  set vacantFrom(value: LocalDate) {
    this._vacantFrom = LocalDate.fromDate(value);
  }
  get vacantTo(): LocalDate {
    return this._vacantTo;
  }
  set vacantTo(value: LocalDate) {
    this._vacantTo = LocalDate.fromDate(value);
  }

  toString(culture?: string): string {
    let value = `${this.rentalId}${this.address && this.address.street ? ', ' + this.address.street + ' ' : ' '}`;
    if (culture && this.vacantFrom) {
      value += `(${this.vacantFrom.toDate().toLocaleDateString(culture)})`;
    }

    return value.trim();
  }

  toAutocompleteValue(viewType: 'list' | 'field', culture?: string): string {
    switch (viewType) {
      case 'field':
        return this.toString();

      case 'list':
        return this.toString(culture);
    }
  }

  toJSON() {
    return { id: this.id };
  }
}
